"use strict";

define('view/attachmentsWithDocStore.tab',['require','exports','module','underscore','appkit/loader.helper','datakit/collection','uikit/uikit','libs/format/date','view/page.list','view/table.ellipsis'],function (require, exports, module) {
  var _ = require('underscore'),
    LoaderHelper = require('appkit/loader.helper'),
    BaseCollection = require('datakit/collection'),
    UIKit = require('uikit/uikit'),
    DateFormatter = require('libs/format/date'),
    PageListView = require('view/page.list'),
    TableEllipsis = require('view/table.ellipsis');
  var COLNAME_ATTACHMENT_ELLIPSIS = 'attachment:ellipsis';
  module.exports = PageListView.extend({
    options: {
      search: true,
      visualsearch: false,
      header: false,
      searchSegmentColor: 'basic',
      searchSegmentAttached: '',
      canDelete: false,
      canUpload: false,
      uploadHandler: function uploadHandler() {},
      tableOptions: {
        collection: new BaseCollection()
      }
    },
    initialize: function initialize() {
      PageListView.prototype.initialize.apply(this, arguments);
      this._setupPropertyRefs();
      this._setupTable();
      this._setupSearchView();
    },
    handleRowAction: function handleRowAction(row, action) {
      var model = row.model;
      model.once('error', function () {
        var previousAttributes = this.previousAttributes();
        _.each(this.changedAttributes(), function (value, changedAttribute) {
          this.set(changedAttribute, previousAttributes[changedAttribute]);
        }, this);
      });
      switch (action.get('action')) {
        case 'delete':
          model.destroy({
            wait: true
          });
          break;
      }
    },
    handleTableRowDoublePress: function handleTableRowDoublePress(row) {
      var model = row.model;
      window.open(model.get('url'));
    },
    setQueryFilter: function setQueryFilter(searchView, value) {
      this.spfHelper.filter.set('q', value);
    },
    updateOption: function updateOption(option, value) {
      return this._setOption(option, value);
    },
    _setupPropertyRefs: function _setupPropertyRefs() {
      this.searchView = this.searchView;
    },
    _setupTable: function _setupTable() {
      this._setupUploadAttachmentsButton();
      this._applyTableOptions();
      this._configureTableColumns();
      this.listenTo(this.table, 'row:action', this.handleRowAction).listenTo(this.table, 'row:double:press', this.handleTableRowDoublePress).listenTo(this.table, 'row:before:add:child', this._setupEllipsisMenu.bind(this));
    },
    _setupSearchView: function _setupSearchView() {
      this.searchView.model = new LoaderHelper([this.table.collection], {
        delay: 0
      });
      this.searchView.bindings.loading = 'loading';
      this.searchView.transparent = true;
      var setSearchViewCSS = function setSearchViewCSS(attachmentsTabView) {
        attachmentsTabView.searchView.$el.parent().css({
          borderTop: 0
        });
      };
      this.listenTo(this, 'render', setSearchViewCSS);
      this.listenTo(this.searchView, 'change:value', _.debounce(this.setQueryFilter, 100));
    },
    _applyTableOptions: function _applyTableOptions() {
      var tableOptions = _.extend({}, {
        emptyText: 'No Attachments.',
        selectable: true,
        focusable: true
      }, this.getOption('tableOptions'));
      for (var opt in tableOptions) {
        this.table[opt] = tableOptions[opt];
      }
    },
    _configureTableColumns: function _configureTableColumns() {
      this.table.columns.add([{
        name: COLNAME_ATTACHMENT_ELLIPSIS,
        text: 'Manage',
        useAccessibilityText: true,
        childView: TableEllipsis,
        childViewOptions: {
          ariaLabel: 'manage attachment'
        },
        collapsing: true
      }, {
        text: 'Filename',
        data: 'fileName'
      }, {
        text: 'Uploaded By',
        data: 'createPerson.displayName',
        sortable: true,
        sort: 'createPerson.lastName'
      }, {
        text: 'Date Uploaded',
        data: 'createDate',
        formatter: DateFormatter('L LT'),
        colspan: 2,
        sortable: true
      }]);
      if (this.getOption('canUpload')) {
        this.table.columns.push({
          view: this.uploadAttachmentsButton,
          collapsing: true
        });
      } else {
        this.table.columns.last().unset('colspan');
      }
    },
    _setupEllipsisMenu: function _setupEllipsisMenu(row, child, model, column) {
      if (COLNAME_ATTACHMENT_ELLIPSIS === column.get('name')) {
        child.view.childBindings.icon = 'icon';
        child.view.childBindings.link = 'link';
        child.view.childBindings.target = 'target';
        child.view.childBindings.visible = 'visible';
        child.collection = new Backbone.Collection([{
          icon: 'download',
          text: 'Download',
          link: model.get('url'),
          target: '_blank'
        }]);
        if (this.getOption('canDelete')) {
          child.collection.push({
            icon: 'trash',
            text: 'Delete',
            action: 'delete'
          });
        }
      }
    },
    _setupUploadAttachmentsButton: function _setupUploadAttachmentsButton() {
      this.uploadAttachmentsButton = new UIKit.Button({
        icon: 'plus',
        text: 'Upload Attachments',
        color: 'secondary',
        compact: true,
        size: 'small'
      });
      this.listenTo(this.uploadAttachmentsButton, 'press', this.getOption('uploadHandler'));
    }
  });
});

